var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-sm-flex"},[_c('UIButton',{staticClass:"m-auto",attrs:{"text":"Select Function","primary":true},on:{"click":function($event){return _vm.toCodeVault(_vm.option.customNode)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }